import classNames from 'classnames';
import React from 'react';

type Props = {
  className?: string;
  title: string | React.ReactNode;
  subtitle?: string;
  rightAddon: React.ReactNode;
};

export const CustomFieldsPageHeader = ({
  className,
  title,
  subtitle,
  rightAddon,
}: Props) => {
  return (
    <div
      className={classNames(
        'flex w-full max-w-lg items-center justify-between self-center',
        className,
      )}
    >
      <div className="mr-24 text-content-primary">
        <div className="text-content-primary heading-l">{title}</div>
        {subtitle && (
          <div className="mt-8 text-content-secondary-bg-primary body-m">
            {subtitle}
          </div>
        )}
      </div>
      <div className="shrink-0">{rightAddon}</div>
    </div>
  );
};
